/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Action_WrappedInputs */

const en_us2_search_action_wrapped = /** @type {(inputs: Search_Action_WrappedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your recap`)
};

const pt_br2_search_action_wrapped = /** @type {(inputs: Search_Action_WrappedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sua retrospectiva`)
};

const es_419_search_action_wrapped = /** @type {(inputs: Search_Action_WrappedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu resumen`)
};

const pt_pt2_search_action_wrapped = /** @type {(inputs: Search_Action_WrappedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A tua retrospetiva`)
};

const fr_fr2_search_action_wrapped = /** @type {(inputs: Search_Action_WrappedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ton bilan`)
};

const de_de2_search_action_wrapped = /** @type {(inputs: Search_Action_WrappedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Rückblick`)
};

const it_it2_search_action_wrapped = /** @type {(inputs: Search_Action_WrappedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il tuo riepilogo`)
};

/**
* | output |
* | --- |
* | "Your recap" |
*
* @param {Search_Action_WrappedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_action_wrapped = /** @type {((inputs?: Search_Action_WrappedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Action_WrappedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_action_wrapped(inputs)
	if (locale === "es-419") return es_419_search_action_wrapped(inputs)
	if (locale === "pt-PT") return pt_pt2_search_action_wrapped(inputs)
	if (locale === "fr-FR") return fr_fr2_search_action_wrapped(inputs)
	if (locale === "de-DE") return de_de2_search_action_wrapped(inputs)
	if (locale === "it-IT") return it_it2_search_action_wrapped(inputs)
	return en_us2_search_action_wrapped(inputs)
});
export { search_action_wrapped as "search.action_wrapped" }